import { render } from "./XIconSolidRadioTower.vue?vue&type=template&id=3d795730"
import script from "./XIconSolidRadioTower.vue?vue&type=script&lang=js"
export * from "./XIconSolidRadioTower.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidRadioTower.vue"]])

export default __exports__